
//import liraries
import { React, useState, useEffect } from "react";
import { View, Text, FlatList, TouchableOpacity, ScrollView, Image,} from "react-native";
import { useDeviceSize } from "rn-responsive-styles";
import { getFAQS } from "../api/serviceRequest";
import UserDetails from "../SubComponents/Dashboard/UserDetails";
import HTMLRenderer from "react-html-renderer";
import Loader from "../common/Loader";
import Sidebar from "../common/Sidebar";
import Header from "../common/Header";
import MobileHeader from "../common/MobileHeader";
import TabHeader from "../common/TabHeader";
import ModalAlert from "../common/ModalAlert";
import { useLogin } from "../context/loginProvider";
import useStyles from "./Help_Styles";
import CDocxViewer from "../common/CDocxViewer";

// create a component
const Help = (props) => {
  const styles = useStyles();
  const deviceSize = useDeviceSize();
  const [isShowSidebar, setIsShowSidebar] = useState(false);
  const [data, setData] = useState({ getFAQ: [] });
  const [loading, setLoading] = useState(false);
  const isSmallDevice = deviceSize === "small" || deviceSize === "extrasmall";
  const isTabView = deviceSize === "medium";
  const [expanded, setExpanded] = useState(null);
  const [alertModalVisible, setAlertModalVisible] = useState(false);
  const { isLoggedIn, setIsLoggedIn } = useLogin();
  const [showLogoutModal, setShowLogoutModal] = useState(false);

 
  useEffect(() => {
    getFAQSQA();
  }, []);

  const getFAQSQA = () => {
    setLoading(true);
    getFAQS()
      .then((res) => {
        // console.log("faq resqq", JSON.stringify(res));
        setData({ getFAQ: res });
        setLoading(false);
      })
      .catch((err) => {
        setLoading(false);
      });
  };

  const toggleExpand = (index) => {
    setExpanded(index);
  };

  return (
    <View>
      <Header />
      <MobileHeader isShowSidebar={setIsShowSidebar} />
      <TabHeader />
      <View style={styles.mainContainer}>
        <View style={styles.contentWidget}>
          {!isShowSidebar && <Sidebar navigation={props.navigation} />}
          <View style={styles.container}>
            {isTabView || isSmallDevice ? null : <UserDetails navigation={props.navigation} />}
            <View style={styles.rechargeBody}>
              <View style={styles.firstViewStyle}>
                <Text style={styles.headerTitle}>{'FAQ’s '}</Text>
                <ScrollView
                  style={{ width: '100%' }}
                  showsVerticalScrollIndicator={false}>
                  <FlatList
                    data={data.getFAQ}
                    style={{ width: '100%', paddingRight: 20 }}
                    // key={random()}
                    keyExtractor={(item, index) => index + '_' + item?.id?.toString()}
                    renderItem={({ item, index }) => {
                      return (
                        <View>
                          <TouchableOpacity
                            style={styles.questionLink}
                            onPress={() => toggleExpand(index)}>
                            <Text style={styles.questionLinkText}>
                              <HTMLRenderer html={item.questn} />
                            </Text>

                            <View
                              style={{
                                alignItems: 'center',
                                justifyContent: 'center',
                              }}>
                              <Image
                                source={expanded == index ? require('../assets/images/arrow_up.png') : require('../assets/images/arrow_down.png')}
                                style={{
                                  width: 10,
                                  height: 10,
                                  alignSelf: 'center',
                                }}
                              />
                            </View>
                          </TouchableOpacity>
                          {expanded != index ? <View style={styles.separator} /> : null}
                          <View style={{}} />
                          {expanded == index && (
                            <View style={{}}>
                              <Text style={styles.answerText}>
                                <HTMLRenderer html={item.answer} />
                              </Text>

                              <View style={styles.separator} />
                            </View>
                          )}
                        </View>
                      );
                    }}
                  />
                </ScrollView>
              </View>
              <View style={styles.secondViewStyle}>
                <Text style={styles.gradTitle}>{'Terms and Conditions'}</Text>
                <View style={[styles.gradBoxOne, { flexDirection: 'row' }]}>
                  <Image
                    source={require('../assets/images/Amitab.png')}
                    style={styles.leftImg}
                  />
                  <View style={styles.gradBoxOneWrapper}>
                    <View style={styles.gradBoxOneWidget}>
                      <Text style={styles.gradSubTitle}>{'Click to view a list of all \nTerms and Conditions'}</Text>
                    </View>
                    <View style={styles.btnWidget}>
                      <TouchableOpacity
                        style={styles.alertLink}
                        onPress={() => {
                          setAlertModalVisible(true);
                        }}>
                        <Image
                          source={require('../assets/images/icon_forward.png')}
                          style={styles.iconForward}
                        />
                      </TouchableOpacity>
                    </View>
                  </View>
                </View>
                <Text style={styles.gradTitle}>{'Contact Us'}</Text>
                <View
                  style={[
                    styles.gradBoxOne,
                    {
                      flexDirection: 'row',
                      backgroundImage: 'linear-gradient(126deg, #cae7d0 12%, #8ccbba 90%)',
                    },
                  ]}>
                  <Image
                    source={require('../assets/images/sing.png')}
                    style={{ width: 150, height: '100%' }}
                  />
                  <View style={styles.customerCareDetails}>
                    <View style={styles.gradBoxOneWidget}>
                      <Text style={[styles.gradSubTitle, { color: '#9c1d25', fontFamily: 'Inter' }]}>{'IDFC FIRST BANK LIMITED'}</Text>
                      <Text style={[styles.gradSubTitle, { color: '#010102' }]}>
                        {`Customer Helpline
${global?.CC_CONTACT}

E-mail Support 
${global?.CC_EMAIL}`}
                      </Text>
                    </View>
                  </View>
                </View>
              </View>
            </View>
            {alertModalVisible && <CDocxViewer type = "FF_TNC" visibility={setAlertModalVisible}/>}
            {loading && <Loader />}
          </View>
        </View>
      </View>
      {showLogoutModal ? (
        <View style={styles.overlayViewStyle}>
          <ModalAlert
            title={'Error'}
            message={global.TimeoutError}
            actionButton={'OK'}
            onCloseModal={() => setIsLoggedIn(false)}
          />
        </View>
      ) : null}
    </View>
  );
};

//make this component available to the app
export default Help;

